import { DeleteParams, EnumData } from "../model/Enum";
import axios from "axios";

export const fetchEnumsByType = async (type: string): Promise<EnumData[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<EnumData[]>(url + "Enums/GetByType?type=" + type);
    return res.data;
};

export const updateEnum = async (enumData: EnumData): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url + "Enums/AddOrUpdate", enumData);
};

export const deleteEnum = async (params: DeleteParams): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.delete<any>(url + "Enums/Delete", { data: params });
};
